<template>
    <div class="changePassword">
        <form action="" id="changePassword">
            <div class="input input2">
                <input type="password"   name="reg_password" :placeholder="$t('placeholder_psd')" autofocus="autofocus" autocomplete="off">
            </div>
            <div class="input input2">
                <input type="password"   name="reg_password" :placeholder="$t('placeholder_psd')" autofocus="autofocus" autocomplete="off">
            </div>
            <div class="input input2">
                <input type="password"   name="reg_password" :placeholder="$t('placeholder_psd')" autofocus="autofocus" autocomplete="off">
            </div>
            <button type="button" id="changePassword_btn" class="login_btn">{{$t("sure_submit")}}</button>

        </form>
    </div>
</template>

<script>
    export default {
        name: "changePassword",
        created(){
            this.$store.commit("set_current", '-1');
            this.$store.commit("set_title", 'personal');
        }
    }
</script>

<style scoped lang="less">
    @import '../../assets/less/loginCommon.less';
.changePassword {
    .media;
}
</style>
